import { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { SoftwareWizardEmployeeFragment } from 'generated/resources/graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'

import SoftwareWizard from '../SoftwareWizard'
import ComparisonBlock from './ComparisonBlock'
import FaqBlock from './FaqBlock'
import GetStartedBlock from './GetStartedBlock'
import InfoPointsBlock from './InfoPointsBlock'
import PaymentsBlock from './PaymentsBlock'

type Props = {
  upsellOnClick?: () => void
  ctaTitle?: string
  employee: SoftwareWizardEmployeeFragment
  onSoftwareCreated: (setupId: number) => void
}

const InitialSetup = ({ upsellOnClick, ctaTitle, employee, onSoftwareCreated }: Props) => {
  const [showNewModal, setShowNewModal] = useState<boolean>(false)

  const handleAddSoftware = () => {
    track(trackingEvents.itManagement.openSoftwareSetupWizard, { initial_setup: true })

    setShowNewModal(true)
  }

  const onClick = upsellOnClick || handleAddSoftware

  return (
    <Box width="full" height="full" justifyContent="center" alignItems="center" paddingTop="s24">
      <GetStartedBlock onClickCta={onClick} ctaTitle={ctaTitle} />
      <PaymentsBlock onClickCta={onClick} ctaTitle={ctaTitle} />
      <InfoPointsBlock onClickCta={onClick} showButton={!ctaTitle} />
      <ComparisonBlock />
      <FaqBlock />
      {showNewModal && (
        <SoftwareWizard
          onSuccess={onSoftwareCreated}
          employee={employee}
          onClose={() => setShowNewModal(false)}
        />
      )}
    </Box>
  )
}

export default InitialSetup
